import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ErpUnitsDataGrid } from "src/components/views/erp/warehouse/masterData/ErpUnitsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/units")({
	staticData: { title: i18n.t("units"), legacyViewKey: "erpUnitsDataTableView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ErpUnitsDataGrid />;
}
